import type { FormValues } from './ImportDrawer.types'

export const MODAL_NAME = 'orders.import'
export const FORM_ID = 'orders.import'

export const INITIAL_VALUES: FormValues = {
  delimiter: '',
  encoding: '',
  files: [],
}
